import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/images/icon-sun.svg'
import _imports_1 from '../assets/images/icon-moon.svg'


const _hoisted_1 = { class: "flex justify-between items-center mb-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "uppercase text-white font-bold text-2xl",
  style: {"letter-spacing":"0.5em"}
}, " todo ", -1)
const _hoisted_3 = { class: "space-y-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fixed bottom-16 text-center right-0 left-0" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "text-gray-500 font-normal text-sm" }, " Drag and drop to reorder list ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_to_do = _resolveComponent("create-to-do")!
  const _component_to_do_list_card = _resolveComponent("to-do-list-card")!
  const _component_to_do_status_filter_card = _resolveComponent("to-do-status-filter-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["py-12 px-8 max-w-md mx-auto", { dark: _ctx.isDarkThemeOn }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.isDarkThemeOn)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
            class: "h-5",
            role: "button",
            src: _imports_0,
            alt: "sun display for light mode"
          }))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
            class: "h-5",
            role: "button",
            src: _imports_1,
            alt: "moon display for dark mode"
          }))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_create_to_do),
      _createVNode(_component_to_do_list_card, { status: _ctx.statusCard }, null, 8, ["status"]),
      _createVNode(_component_to_do_status_filter_card, {
        onChangeStat: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setStatusCard($event)))
      })
    ]),
    _hoisted_4
  ], 2))
}